<template>
    <div id="play-game">
        <img @click="ctrl_game.startGame()" id="play-game" src="assets/images/background.png" alt="">
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ctrl_game: this.ctrl_game(),
            }
        }
    }
</script>